// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import firebase from "firebase";
// import { auth } from "firebase/auth";

import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAvfjavnOQoXNkzCBlkVFETdvB92196xqI",
  authDomain: "clone-2e3f7.firebaseapp.com",
  projectId: "clone-2e3f7",
  storageBucket: "clone-2e3f7.appspot.com",
  messagingSenderId: "205562758594",
  appId: "1:205562758594:web:b3435e99d1b9e7fbbbc25b",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore();
const auth = getAuth();
const provider = new GoogleAuthProvider();

export { db, auth, provider };
